import { render, staticRenderFns } from "./BigNumber.vue?vue&type=template&id=db4f0a02&scoped=true&"
import script from "./BigNumber.vue?vue&type=script&lang=js&"
export * from "./BigNumber.vue?vue&type=script&lang=js&"
import style0 from "./BigNumber.vue?vue&type=style&index=0&id=db4f0a02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4f0a02",
  null
  
)

export default component.exports